import services from './services.js';
import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';

export default {
    methods: {
        /*支付，寄送*/
        getPay(type) {
            let Params = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession, ParmType: type }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }

                });
            });
        },
        getLogistics(type) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                ParmType: 10,
            };

            GetParmConfig(para).then(res => {

                util.doResult(this, res, () => {
                    this.Logistics = res.data.Data;
                    if (type == "1") {
                        //this.AddForm.LogisticsId = this.Logistics[this.Logistics.length - 1].Id;
                    }
                });
            });
        },
        req_getOrderData(val) {
            let params = { Sid: this.sysSid, Session: this.sysSession, Id: val };
            $http.get("api/Order/GetERP_OrderById", params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.OrderData = Data;
                    this.equipmoney = this.OrderData.DiscountTemplet.CostHiPrePayMoney;
                    this.accountmoney = this.OrderData.DiscountTemplet.CostAccountBalance;
                    this.form.RefundPrice = this.OrderData.OrderActualPrice;
                    this.dialogVisible = true;
                });
            });
        },
        req_submit() {
            this.submitLoding = true;
            $http.post("api/Order/RefundOrderEx", this.form).then(res => {
                this.submitLoding = false;
                util.doResult(this, res, () => {
                    this.dialogVisible = false;
                    this.$notify({
                        title: "成功",
                        message: "退款审核成功",
                        type: "success"
                    });
                    this.$emit('reloadList');
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/components/orderInvoice/services.js